module.exports = __webpack_public_path__ + "static/b04dbc0b1fec46f1c4b876c1823723136ff223a321bdb27280d2225e46b1d498-b6469f2dc14361028068673bb61df0c9.png";